<template>
    <div class="box-body">
        <div v-if="customer._id && customer.isRemoved" class="alert m-b-md" style="background: repeating-linear-gradient(45deg, #fff3cd, #fff3cd 10px, #ffeaa0 10px, #ffeaa0 20px); border: 2px solid #e0a800; border-radius: 4px; padding: 14px 18px; display: flex; align-items: center; gap: 12px;">
            <i class="material-icons" style="font-size: 28px; color: #b07d00;">archive</i>
            <div>
                <strong style="color: #7a5500; font-size: 15px;">Archiwalna kartoteka</strong>
                <div style="color: #7a5500; font-size: 13px;">Ta kartoteka klienta została oznaczona jako usunięta. Dane mają charakter archiwalny.</div>
            </div>
        </div>
        <div v-if="customer._id && sameCustomers.length > 0" class="alert m-b-md" style="background: #fff0f0; border: 2px solid #dc3545; border-radius: 4px; padding: 14px 18px; display: flex; align-items: flex-start; gap: 12px;">
            <i class="material-icons" style="font-size: 28px; color: #dc3545; flex-shrink: 0; margin-top: 2px;">warning</i>
            <div>
                <strong style="color: #a71d2a; font-size: 15px;">Zduplikowany NIP — wymagana weryfikacja</strong>
                <div style="color: #a71d2a; font-size: 13px; margin-top: 4px;">
                    W systemie istnieją inne aktywne kartoteki z tym samym numerem NIP. Sprawdź, czy nie należy ich scalić:
                </div>
                <ul style="margin: 6px 0 0 0; padding-left: 18px;">
                    <li v-for="c in sameCustomers" :key="c._id" style="font-size: 13px;">
                        <router-link :to="'/customers/' + c._id" style="color: #a71d2a; text-decoration: underline;">
                            {{ c.name || c._id }}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row">
            <Spinner v-if="isLoaded"/>
            <div class="col-md-3">
                <Details v-if="customer._id" :customerData="customer" @deliveryUpdate="onDeliveryChange" />
                <DeliverAdresses v-if="customer._id" :customerData="customer" @deliveryUpdate="onDeliveryChange" />
                <div v-if="customer._id && user != null && UserManager.hasPermission('view.customers')" class="m-t-sm m-b-sm">
                    <a href="#" class="text-blue text-sm" @click.prevent="mergeCustomer">
                        <i class="material-icons md-18" style="vertical-align: middle;">merge_type</i>
                        Połącz z inną kartoteką
                    </a>
                </div>
                <router-link class="nav-link text-muted hover-dark" to="/customers" v-if="user != null && UserManager.hasPermission('view.customers')">
                    <span class="text-sm">Powrót do list klientów</span>
                </router-link>
            </div>
            <div class="col-md-6">
                <div class="box" v-if="customer._id">
                    <div class="box-header d-gray">
                        <h6 class="text-muted _400 inline" style="vertical-align: middle;"/>
                    </div>
                    <div class="box-divider m-a-0"/>
                    <div>
                        <div class="l-gray p-b">
                            <ul class="btn-group nav nav-pills p-t p-l">
                                <li class="nav-item">
                                    <a class="btn btn-sm white none-radius primary-color"
                                       @click="currentTab = 'labels'" :class="{ 'active': currentTab == 'labels'}">
                                        <span class="_400">Etykiety klienta</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="btn btn-sm white none-radius primary-color"
                                       @click="currentTab = 'iso-evals'" :class="{ 'active': currentTab == 'iso-evals'}">
                                        <span class="_400">Ankiety dostaw</span>
                                    </a>
                                </li>
                                <li class="nav-item" v-if="hasEvaluations">
                                    <a class="btn btn-sm white none-radius primary-color"
                                       @click="currentTab = 'qualifications'" :class="{ 'active': currentTab == 'qualifications'}">
                                        <span class="_400">Decyzje kwalifikacyjne</span>
                                    </a>
                                </li>
                                <!-- <li class="nav-item">
                                    <a class="btn btn-sm white none-radius primary-color"
                                    v-on:click="currentTab = 'clientCodes'" v-bind:class="{ 'active': currentTab == 'clientCodes'}">
                                    <span class="_400">Wysyłka</span>
                                    </a>
                                </li> -->
                            </ul>
                        </div>
                        <div class="box-divider m-a-0"/>
                        <div class="tab-content m-b-md">
                            <div class="tab-pane animated fadeIn active text-muted">
                                <CustomerLabels v-if="currentTab == 'labels'" :customer="customer"/>
                                <CustomerSupplierEvaluationCard v-if="currentTab == 'iso-evals'" :customer="customer"/>
                                <CustomerSupplierQualifications v-if="currentTab == 'qualifications'" :customer="customer"/>
                            </div>
                        </div>

                    </div>
                </div>
                <CustomerOrderHistory v-if="customer._id" :customer="customer"/>
            </div>
            <div class="col-md-3">
                <WfirmaUnsettledPayments v-if="customer._id" :customer="customer"/>
                <PickupPoints v-if="customer._id" :customerData="customer"/>
            </div>
        </div>
    </div>
</template>
<script>
import Api from '../../Api.js';
import Spinner from '../Spinner.vue';
import DeliverAdresses from './DeliverAdresses.vue';
import Details from './Details.vue';
import CustomerLabels from './CustomerLabels.vue';
import PickupPoints from './PickupPoints.vue';
import WfirmaUnsettledPayments from './WfirmaUnsettledPayments.vue';
import CustomerOrderHistory from './CustomerOrderHistory.vue';
import CustomerSupplierEvaluationCard from './CustomerSupplierEvaluationCard.vue';
import SelectCustomerModal from '../CRM/SelectCustomerModal.vue';
import CustomerSupplierQualifications from './CustomerSupplierQualifications.vue';
import UserManager from '../../UserManager.js'

export default {
    name: 'CustomerCard',
    components: {
        Spinner,
        Details,
        DeliverAdresses,
        CustomerLabels,
        PickupPoints,
        WfirmaUnsettledPayments,
        CustomerOrderHistory,
        CustomerSupplierEvaluationCard,
        CustomerSupplierQualifications
    },
    data: function () {
        return {
            isLoaded: false,
            customer: {},
            currentTab: 'labels',
            user: UserManager.user,
            UserManager,
            showReplyModal: false,
            replyMessage: {},
            sameCustomers: [],
            hasTickets: false,
            hasEvaluations: false
        }
    },
    created: async function() {
        this.isLoaded = true;
        try {
            const customer = await Api.customer.get(this.$route.params.id);
            this.customer = customer;

            const { data: sameCustomers } = await Api.customer.search({ taxNo: customer.taxNo, limit: 5 });
            this.sameCustomers = sameCustomers.filter(c => c._id !== customer._id);

            const { total: evalTotal } = await Api.iso.suppliers.evaluations.get({ supplierId: customer._id, limit: 1 });
            this.hasEvaluations = evalTotal > 0;
        } catch (error) {
            this.$h.commonApiError(error, true);
        }
        this.isLoaded = false;
        UserManager.events.on('userReady', () => {
            this.user = UserManager.user;
        });
    },
    methods: {
        onDeliveryChange(cust) {
            this.customer = cust;
        },
        openReplyModal(msg) {
            this.replyMessage = msg;
            this.showReplyModal = true;
        },
        onTicketsLoaded(tickets) {
            this.hasTickets = Array.isArray(tickets) && tickets.length > 0;
        },

        /**
         * Otwiera modal wyboru kartoteki źródłowej (B), prosi o potwierdzenie i wykonuje scalenie
         * kartoteki B w kartotekę bieżącą (A). Operacja jest nieodwracalna — kartoteka B zostaje
         * oznaczona jako usunięta, a jej adresy dostawy i zamówienia są przenoszone do A.
         */
        async mergeCustomer() {
            const sourceId = await this.$modal2.show(SelectCustomerModal, {});
            if (!sourceId) return;

            if (sourceId === this.customer._id) {
                this.$h.error('Nie można scalić kartoteki z samą sobą.');
                return;
            }

            const confirmed = await this.$h.confirm(
                'Scalenie kartotek jest NIEODWRACALNE. Wybrana kartoteka źródłowa zostanie ' +
                'oznaczona jako usunięta, a jej adresy dostawy i zamówienia zostaną przeniesione ' +
                'do tej kartoteki. Kontynuować?'
            );
            if (!confirmed) return;

            this.isLoaded = true;
            try {
                const result = await Api.customer.merge(this.customer._id, sourceId);
                this.customer = result.customer;
                this.$h.success(
                    `Scalono kartoteki. Przeniesionych zamówień: ${result.ordersAfterMove}, ` +
                    `z remapowanym adresem: ${result.ordersWithRemappedAddress}.`
                );
            } catch (e) {
                this.$h.commonApiError(e);
            }
            this.isLoaded = false;
        }
    }
}
</script>
